import { Grid, Skeleton } from "@mui/material";
import { RootState } from "app/reducers";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import DeviceCard from "./DeviceCard";
import { Devices } from "./reducers/index.model";
import Confused from "../../assets/icons/global-icon-20_Confused.svg";
import helpIcon from "../../assets/icons/global-icon-black-help.svg";
import SortIcon from "../../assets/icons/sort-icon.svg";
import iconClose from "../../assets/icons/icon-white-close.svg";
import Tooltip from "app/common/Tooltip";
import { ComponentsContent } from "app/common/NumberCard/NumberCardContent";
import { ManageDeviceActionTypes } from "./actions/index.model";
import moment from "moment-timezone";
import CustomMenu from "app/common/Menu";

export default function SignedInDevicesList(): React.ReactElement {
  const content = ComponentsContent?.ManageSignIn;
  const manageDevices = useSelector((state: RootState) => state.manageDevices);
  
  console.log(JSON.stringify(manageDevices))
  const [sortType, setSortType] = useState("DESC");
  //const allowedCategories = ["alexa", "cdigits", "webdigits"];
  const [selectedTooltip, setSelectedTooltip] = React.useState(false);
  const apiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === ManageDeviceActionTypes.MANAGE_DEVICES_STATUS
    )
  );
  const handleTooltip = () => {
    setSelectedTooltip(true);
  };

  const handleCloseTooltip = () => {
    setSelectedTooltip(false);
  };

  const getDeviceLength = () => {
    // const filteredDevices = manageDevices.devices.filter(
    //   (device: any) =>
    //     allowedCategories.indexOf(device.applicationCategory?.toLowerCase()) >
    //     -1
    // );
    return manageDevices.devices.length;
  };

  const onSortChange = (sortType: string) => {
    setSortType(sortType);
  };

  const formatDate = (data: any) => {
    const date = new Date(0);
    date.setUTCSeconds(data);
    const zone = moment.tz(moment.tz.guess()).zoneAbbr();
    return moment(date).format("MMM DD, YYYY, hh:mm:ss A") + " " + zone;
  };

  React.useEffect(() => {
    document.body.addEventListener("click", handleCloseTooltip);
    return () => {
      document.body.removeEventListener("click", handleCloseTooltip);
    };
  }, []);

  const sortUtil = (a: any, b: any) => {
    if (sortType === "ASC") {
      return a.lastLoginTime - b.lastLoginTime;
    } else {
      return b.lastLoginTime - a.lastLoginTime;
    }
  };

  const getIcon = () => {
    return (
      <img
        src={SortIcon}
        className="sortIcon"
        alt={"sortIcon"}
        width="14px"
        height={"14px"}
      />
    );
  };

  return (
    <React.Fragment>
      <Grid item container rowSpacing={2}>
        <Grid item xs={12}></Grid>

        <Grid item xs={12} container rowSpacing={2}>
          <Grid item xs={12}>
            <div className="header signed">
              <div className="header-text" tabIndex={0}>
                Manage signed-in devices
                <Tooltip
                  title={
                    <>
                      <div className="tooltipClose">
                        <img
                          src={iconClose}
                          alt={"close"}
                          width="14px"
                          height={"14px"}
                          onClick={() => handleCloseTooltip()}
                        />
                      </div>
                      {content.toolTipsTitle.helpIcon}
                    </>
                  }
                  placement={"top"}
                  open={selectedTooltip}
                >
                  <span className="help-icon">
                    <img
                      src={helpIcon}
                      alt={`help icon ${content.toolTipsTitle.helpIcon}`}
                      tabIndex={0}
                      width="16px"
                      height="16px"
                      onClick={() => handleTooltip()}
                    />
                  </span>
                </Tooltip>
              </div>
              <div className="header-sortcontainer">
                <div className="header-timestamp">
                  <CustomMenu
                    label="Last log-in"
                    icon={getIcon()}
                    onMenuCB={onSortChange}
                  />
                </div>
                <div tabIndex={0} className="header-deviceLength">
                  <span>{getDeviceLength() + " Devices"}</span>
                  {/* <span> (Sign-in limit reached)</span>{" "} */}
                </div>
              </div>
            </div>
            <div>
              {!manageDevices.loading && manageDevices.devices.length === 0 && (
                <>
                  {apiStatus?.status === "error" && (
                    <div className="nodata signed-devices">
                      <img
                        src={Confused}
                        alt={"Confused Icon"}
                        tabIndex={0}
                        width="32px"
                        height="32px"
                      />
                      <span tabIndex={0}>Please try again later.</span>
                    </div>
                  )}
                  {apiStatus?.status === "final" && (
                    <div className="numberCardContainer ">
                      <div className="deviceAvataar"></div>
                      <div className="contentContainer">
                        <div className="leftContent ">
                          <div className="nodata" tabIndex={0}>
                            <span>
                              You do not have any devices signed-in to DIGITS.
                            </span>
                            <div></div>
                          </div>
                        </div>
                        <div className="divider"></div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {!manageDevices.loading &&
                manageDevices.devices.length > 0 &&
                manageDevices.devices
                  .sort(sortUtil)
                  .map((device: Devices, index: number) => {
                    // if (
                    //   allowedCategories.indexOf(
                    //     device.applicationCategory?.toLowerCase()
                    //   ) > -1
                    // ) {
                    return (
                      <DeviceCard
                        key={index}
                        deviceId={device.deviceId}
                        deviceName={device.deviceName}
                        category={device.applicationCategory}
                        lastLoginTime={formatDate(device.lastLoginTime)}
                        ownerId={device.ownerId}
                      />
                    );
                    // }
                  })}

              {manageDevices.loading && (
                <>
                  <Skeleton
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  ></Skeleton>
                  <Skeleton
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  ></Skeleton>
                  <Skeleton
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  ></Skeleton>
                  <Skeleton
                    style={{
                      width: "100%",
                      height: "50px",
                    }}
                  ></Skeleton>
                </>
              )}
            </div>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
